import {
  SandboxTaskDecisionResource,
  SandboxTaskDecisionResourceConfig
} from './sandbox-task-decision-resource';

export const getSandboxTaskDecisionResource = (
  config?: SandboxTaskDecisionResourceConfig
) => new SandboxTaskDecisionResource(config);
